import React from "react";
import {
  Avatar,
  Box,
  ButtonBase,
  Grid,
  Typography,
  useTheme
} from "@material-ui/core/index";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { useHistory } from "react-router-dom";
import paths from "../../../routes/paths";
import { insiders } from "../../../mocks";

export default function ReportListItem(props) {
  const { passenger, greyBackground, onPress } = props;
  const classes = styles();
  const history = useHistory();
  const theme = useTheme();

  return (
    <ButtonBase
      className={classes.buttonContainer}
      onClick={() =>
        onPress(passenger)
      }
    >
      <Grid
        className={classes.container}
        style={{
          backgroundColor: greyBackground
            ? theme.palette.grey.light
            : theme.palette.white
        }}
        container
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid
          item
          container
          xs={2}
          direction={"column"}
          justify="center"
          alignItems="center"
        >
          <Avatar className={classes.avatar}>{passenger.gate}</Avatar>
          <Typography className={classes.status}>Gates</Typography>
        </Grid>
        <Grid container item direction={"column"} xs={9}>
          <Box borderBottom={1} className={classes.nameBox}>
            <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="center"
            >
              <Typography className={classes.passName}>
                {passenger.name} {passenger.surname}
              </Typography>
              <Typography className={classes.opName}>
                op. {insiders[Math.floor(Math.random() * insiders.length)]}
              </Typography>
            </Grid>
          </Box>
          <Grid container justify={"space-between"} direction={"row"}>
            <Grid>
              <Typography className={classes.infoTitle}>Prm</Typography>
              <Typography className={classes.info}>{passenger.type}</Typography>
            </Grid>
            <Grid>
              <Typography className={classes.infoTitle}>Station</Typography>
              <Typography className={classes.info}>
                {Math.floor(Math.random() * 100)}
              </Typography>
            </Grid>
            <Grid>
              <Typography className={classes.infoTitle}>Posizione</Typography>
              <Typography className={classes.info}>
                Gate {passenger.gate}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid xs={1} item justify="flex-end" alignItems="center" container>
          <ChevronRightIcon className={classes.arrowIcon} />
        </Grid>
      </Grid>
    </ButtonBase>
  );
}

const styles = makeStyles(theme => ({
  buttonContainer: {
    width: "100%"
  },
  container: {
    padding: 8
  },
  avatar: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.black
  },
  status: {
    fontSize: 10,
    fontWeight: "700",
    color: theme.palette.grey.dark,
    marginTop: 5
  },
  nameBox: {
    borderColor: theme.palette.divider
  },
  passName: {
    fontSize: 14,
    fontWeight: "600",
    color: theme.palette.black
  },
  opName: {
    fontSize: 14,
    fontWeight: "400",
    color: theme.palette.grey.dark
  },
  infoTitle: {
    fontSize: 12,
    fontWeight: "200",
    color: theme.palette.grey.dark
  },
  info: {
    fontSize: 12,
    fontWeight: "600",
    color: theme.palette.grey.dark
  },
  arrowIcon: {
    color: theme.palette.grey.dark
  }
}));
